module.exports = __webpack_public_path__ + "static/media/teletava2.2832e1f6.png";